/*! Copyright (c) 2016 THE ULTRASOFT (http://theultrasoft.com)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Project: Parallaxie
 * Version: 0.5
 *
 * Requires: jQuery 1.9+
 */

(function ($) {
    $.fn.parallaxie = function (options) {
        options = $.extend(
            {
                speed: 0.2,
                repeat: 'no-repeat',
                size: 'cover',
                posX: 'center',
                offset: 0,
            },
            options,
        )

        this.each(function () {
            const $el = $(this)
            let localOptions = $el.data('parallaxie')
            if (typeof localOptions !== 'object') localOptions = {}
            localOptions = $.extend({}, options, localOptions)

            let imageUrl = $el.data('image')
            if (typeof imageUrl === 'undefined') {
                imageUrl = $el.css('background-image')
                if (!imageUrl) return

                // APPLY DEFAULT CSS
                const posY = localOptions.offset + ($el.offset().top - $(window).scrollTop()) * (1 - localOptions.speed)
                $el.css({
                    'background-image': imageUrl,
                    'background-size': localOptions.size,
                    'background-repeat': localOptions.repeat,
                    'background-attachment': 'fixed',
                    'background-position': `${localOptions.posX} ${posY}px`,
                })

                $(window).scroll(() => {
                    // let posY = - ( $(window).scrollTop() - $el.offset().top ) * ( 1 + localOptions.speed ) - ( $el.offset().top * localOptions.speed );
                    const posY
                        = localOptions.offset + ($el.offset().top - $(window).scrollTop()) * (1 - localOptions.speed)
                    $el.data('posY', posY)
                    $el.css('background-position', `${localOptions.posX} ${posY}px`)
                })
            }
        })
        return this
    }
}(window.jQuery))
